import { Injectable } from '@angular/core';
import { BehaviorSubject, finalize } from 'rxjs';
import { AuthenticatedUserModel } from '../../../utils/types/models/auth.model';
import {SecureStorageService, TimeHelpers} from 'ngx-secure-storage';
import { Router } from '@angular/router';
import { ApiService } from '../api/api.service';
import { ToastrService } from '../toast/toastr.service';
import { Store } from '../../../utils/stores';
import { ApiResponse } from '../../../utils/types/models/api.model';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private userSubject = new BehaviorSubject<AuthenticatedUserModel | null>(null);
  user$ = this.userSubject.asObservable();

  constructor(
    private storage:SecureStorageService,
    private router:Router,
    private api:ApiService,
    private toastr:ToastrService,
  ) {
    this.getUserFromStorage()
  }

  get isLoggedIn(){
    return !!this.userSubject.value?.user
  }

  get user() {
    return  this.userSubject.value;
  }

  private getUserFromStorage() {
    const sessionExpiryTime = this.storage.retrieve(Store.SESSION_EXPIRY_TIME_STORE, true);
    const currentTime = Date.now();

    const user = this.storage.retrieve(Store.SESSION_STORE, true);
    this.userSubject.next((!!sessionExpiryTime && (currentTime < Number(sessionExpiryTime))) && (user || null));
  }


  login(user: AuthenticatedUserModel){
    this.storage.store(Store.SESSION_STORE, user, true, 3600000 /* 60 mins (1hr) time-to-live */);
    this.storage.store(Store.SESSION_EXPIRY_TIME_STORE, (Date.now() + 3600000), true, 3600000);

    this.userSubject.next(user as AuthenticatedUserModel);
    this.router.navigate(['/']);
  }

  logout(){
    this.api.get('/api/v1/auth/logout')
      .pipe(finalize(() => { this.onLogout(); }))
      .subscribe({
        error: (e) => { document.cookie = 'cac-auth-token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;' }
      });
  }

  onLogout(){
    this.storage.delete(Store.SESSION_EXPIRY_TIME_STORE);
    this.storage.delete(Store.SESSION_STORE);
    this.userSubject.next(null);
    this.router.navigate(['/auth']);
  }

  refreshUser(){
    if (!this.user?.refreshToken){
      return this.onLogout();
    }

    this.api.post('/api/v1/auth/refresh', this.user?.refreshToken).subscribe({
      next: (d:ApiResponse) => {

        const updatedInfo:AuthenticatedUserModel = this.user!;
        updatedInfo['token'] = d.data;

        this.storage.store(Store.SESSION_STORE, updatedInfo, true, TimeHelpers.minuteToMs(30));
        this.userSubject.next(updatedInfo as AuthenticatedUserModel);

        const currentUrl = this.router.url;
        if (currentUrl.startsWith('/auth')) {
          this.router.navigate(['/']);
        }
      },
      error: (e) => {
        if (e.status == 401 || e.status == 403) {
          this.onLogout();
        }
      }
    })
  }
}
